export default {
    finish() {
        this.$store.set('tryout/finishDialog', true)
    },

    doneClass() {
        const counter = this.$store.get('tryout/answers')
            .filter(answer => !!answer.answer_id && ! answer.flagged)
            .length

        if (counter === this.$store.get('tryout/questions').length) {
            return 'success'
        }
    },
}
